import { _ as _defineProperty, a as _inherits, b as _createClass, c as _objectWithoutProperties, d as _objectSpread2, e as _classCallCheck, f as _callSuper } from '../_helpers/_rollupPluginBabelHelpers.js';
import 'core-js/modules/es.array.concat.js';
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import joinDataTestAttributes from '../global/data-tests.js';
import LoaderCore from './loader__core.js';
import { jsx } from 'react/jsx-runtime';
import 'core-js/modules/es.array.reduce.js';
import 'core-js/modules/es.object.entries.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.array.fill.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import '../global/dom.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.set.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/web.dom-collections.iterator.js';

var _excluded = ["message", "size", "colors", "data-test", "stop", "deterministic"];
var Loader = /*#__PURE__*/function (_PureComponent) {
  function Loader() {
    var _this;
    _classCallCheck(this, Loader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Loader, [].concat(args));
    _defineProperty(_this, "loader", void 0);
    _defineProperty(_this, "initLoader", function (el) {
      if (el) {
        _this.loader = new LoaderCore(el, _this.props);
      }
    });
    return _this;
  }
  _inherits(Loader, _PureComponent);
  return _createClass(Loader, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.loader) {
        if (!prevProps.stop && this.props.stop) {
          this.loader.stopAnimation();
        } else if (prevProps.stop && !this.props.stop) {
          this.loader.startAnimation();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$loader;
      (_this$loader = this.loader) === null || _this$loader === void 0 || _this$loader.destroy();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props;
        _this$props.message;
        _this$props.size;
        _this$props.colors;
        var dataTest = _this$props['data-test'];
        _this$props.stop;
        _this$props.deterministic;
        var restProps = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/jsx("div", _objectSpread2(_objectSpread2({
        "data-test": joinDataTestAttributes('ring-loader', dataTest)
      }, restProps), {}, {
        ref: this.initLoader
      }));
    }
  }]);
}(PureComponent);
_defineProperty(Loader, "propTypes", {
  className: PropTypes.string,
  size: PropTypes.number,
  colors: PropTypes.array,
  message: PropTypes.string,
  'data-test': PropTypes.string,
  stop: PropTypes.bool,
  deterministic: PropTypes.bool
});

export { Loader as default };
